import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";

const Maghzine = () => {
  const [pageMessage, setPageMessage] = useState("Hello,I'mInMaghzinePageFa");

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: pageMessage,
    });
  };

  return (
    <div className="container-fluid">
      <div className="row no-gutters">
        <div className="col-12">
          <div className="d-flex mb-3 align-items-center">
            <div className="d-flex flex-column ml-2">
              <p className="d-flex mb-2 align-items-center">
                <span className="font-medium font-18 mode-text-2">
                  بازی‌های شناختی مهروبو
                </span>
              </p>
            </div>
          </div>
          <div className="boxes my-4">
            <a
              href="/fa/panel/games/maghzine/online?name=AuditoryVisualCorsiblock"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MusicoboIcon} alt='icon-scobo'></img> */}
              <span className="font-14 mt-3 mode-text-7">کرسی بلاک</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                مهار پاسخ، سرعت عمل
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=Clouds"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MusicoboIcon} alt='icon-scobo'></img> */}
              <span className="font-14 mt-3 mode-text-7">ابرهای بارانی</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه تقسیم شده، حافظه کاری، سرعت عمل
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=ControlResponsible"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MaghzineIcon} alt='icon-scobo' style={{width: '75px', height: '75px'}}></img> */}
              <span className="font-14 mt-3 mode-text-7">مسئول کنترل</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه متمرکز، توجه پایدار، حافظه کاری، سرعت عمل، هوشیاری
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=DeliciouseFinder"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MaghzineIcon} alt='icon-scobo' style={{width: '75px', height: '75px'}}></img> */}
              <span className="font-14 mt-3 mode-text-7">خوشمزه یاب</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه انتخابی، جابه‌جایی توجه، سرعت عمل
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=Highway"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MaghzineIcon} alt='icon-scobo' style={{width: '75px', height: '75px'}}></img> */}
              <span className="font-14 mt-3 mode-text-7">بزرگراه</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه انتخابی، مهار پاسخ، سرعت عمل
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=HoneyMemory"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MusicoboIcon} alt='icon-scobo'></img> */}
              <span className="font-14 mt-3 mode-text-7">حافظه عسلی</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                گستره توجه، حافظه کاری، هوشیاری
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=LostInLake"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MusicoboIcon} alt='icon-scobo'></img> */}
              <span className="font-14 mt-3 mode-text-7">گمشده در دریا</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه انتخابی، مهار پاسخ، سرعت عمل
              </span>
            </a>
            <a
              href="/fa/panel/games/maghzine/online?name=Puzzle"
              className="box d-flex flex-column align-items-center justify-content-center"
            >
              {/* <img src={MaghzineIcon} alt='icon-scobo' style={{width: '75px', height: '75px'}}></img> */}
              <span className="font-14 mt-3 mode-text-7">پازل</span>
              <span className="font-10 mt-3 mode-text-7 d-flex w-80 justify-content-center">
                توجه انتخابی، جابجایی توجه
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maghzine;
